import TemplateView from '../../../../TemplateView'

export default class TableCell extends TemplateView {
    constructor({
        content = null,
        cellClass = '',
    }) {
        super(null)

        this.params = {
            content,
            cellClass,
        }
    }

    templateHtml() {
        return '<td></td>'
    }

    afterRender() {
        this.$el.addClass(this.params.cellClass)
        if(this.params.content !== null) {
            this.params.content.init(this.$el)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/TableCell.js